import { useLocalSearchParams, router } from 'expo-router';

import { PeopleScreen } from '@/components/domain/members/PeopleScreen';
import { nearbyFilterOptions, type NearbyFilterOption } from '@/constants/lists';

function isValidOption(option: string | string[] | undefined): option is NearbyFilterOption {
  if (typeof option !== 'string') return false;
  return nearbyFilterOptions.includes(option as NearbyFilterOption);
}

export default function PeopleNearbyFilterScreen() {
  const { option } = useLocalSearchParams<{ option: string }>();

  if (!isValidOption(option)) {
    router.replace('/people/nearby/recent');
    return null;
  }

  return <PeopleScreen listType="nearby" nearbyFilter={option} />;
}
